import { variables, $ } from '../common/variables';
import { cl, ajax } from '../common/functions';

const jsonExport = () => {
  let exportBtn = document.getElementById('dwn-btn');
  // Start file download.
  if (exportBtn !== null) {
    let exportJson = (filename, text) => {
      let element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    };
    // prettier-ignore
    exportBtn.addEventListener('click', function () {
      // Generate download file with some content
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, '0');
      let mm = String(today.getMonth() + 1).padStart(2, '0');
      let yyyy = today.getFullYear();
      today = `${dd}-${mm}-${yyyy}`;
      let text = JSON.stringify(json_file);
      let filename = `glanumLeafletExport-${today}.json`;
      exportJson(filename, text);
    }, false);
  }

}
export { jsonExport }
